<template>
  <FormWizard recaptcha :loading="isLoading" @submit="onSubmit">
    <AgilityField :prefix="formType" />

    <HiddenField name="form-type" :modelValue="formType" />
    <HiddenField name="csrfmiddlewaretoken" :modelValue="csrf" />
    <HiddenField name="destination" :modelValue="destination" />
    <HiddenField name="redir_ok" :modelValue="successUrl" />
    <HiddenField name="redir_err" :modelValue="failUrl" />
    <HiddenField name="origin" :modelValue="originUrl" />

    <FormStep terms-field>
      <slot name="fields"></slot>
    </FormStep>

    <template #submit="submitProps">
      <SubmitButton v-bind="submitProps">Send Message</SubmitButton>
    </template>
  </FormWizard>
</template>

<script lang="ts">
type ContactFormProps = {
  csrf: string;
  destination: string;
  successUrl: string;
  failUrl: string;
  originUrl: string;
};
</script>

<script lang="ts" setup>
import HiddenField from "@/components/fields/HiddenField.vue";
import { sendFormData } from "@/lib/submitForm";
import { GenericObject } from "vee-validate";
import { ref } from "vue";
import FormWizard from "./FormWizard.vue";
import SubmitButton from "./SubmitButton.vue";
import FormStep from "./FormStep.vue";

const formType = "contact-us";

const props = defineProps<ContactFormProps>();

const isLoading = ref(false);

const onSubmit = async (values: GenericObject) => {
  const data: Record<string, unknown> = {
    ...values,
  };

  isLoading.value = true;

  try {
    await sendFormData("/forms/", data);
  } catch (error) {
    console.error("Error while submitting the form.", error);
    document.location.href = props.failUrl;
    return;
  } finally {
    isLoading.value = false;
  }

  document.location.href = props.successUrl;
};
</script>
